import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getTimeZoneOffset } from "../../../../../../_metronic/_helpers/GlobalHelpers";

const GenerateMasterInvoiceModal = ({
  ids,
  show,
  setShow,
  setShowInvoiceModal,
  startDate,
  endDate,
  search
}) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const history = useHistory();
  const handleGenerateInvoce = () => {
    setIsLoading(true);
    fetch(
      `${BASE_URL}/PharmacyAdminManagement/GenerateMasterInvoice?Number=${encodeURIComponent(invoiceNumber)}&pharmacyAdminId=${id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        Allow: "POST",
        body: JSON.stringify(ids),
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Master Invoice has been generated successfully",
          });
          document.getElementById("refreshMasterInvoice").click();
          setShow(false);
          setShowInvoiceModal(false);
        } else if (data[0] === 400 && data[1].message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data[1].message,
          });
        } else if (data[0] === 400) {
          let tt = JSON.parse(data[1]);
          for (const [key, value] of Object.entries(tt.errors)) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: value,
            });
          }
        } else if (data[0] === 401) {
          history.push("/logout");
        } else if (data[0] === 402) {
          Swal.fire({
            title: "Info!",
            text: "You have to subscribe first!",
            icon: "info",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/user-profile");
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleGenerateInvoceByFilter = () => {
    setIsLoading(true);
    fetch(
      `${BASE_URL}/PharmacyAdminManagement/GenerateMasterInvoiceFilter?masterInvoiceNumber=${encodeURIComponent(invoiceNumber)}&pharmacyAdminId=${id}&search=${search}&startDate=${startDate || ""}&endDate=${endDate || ""}&timezone=${getTimeZoneOffset()}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        Allow: "POST",
        body: JSON.stringify(ids),
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Master Invoice has been generated successfully",
          });
          document.getElementById("refreshMasterInvoice").click();
          setShow(false);
          setShowInvoiceModal(false);
        } else if (data[0] === 400 && data[1].message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data[1].message,
          });
        } else if (data[0] === 400) {
          let tt = JSON.parse(data[1]);
          for (const [key, value] of Object.entries(tt.errors)) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: value,
            });
          }
        } else if (data[0] === 401) {
          history.push("/logout");
        } else if (data[0] === 402) {
          Swal.fire({
            title: "Info!",
            text: "You have to subscribe first!",
            icon: "info",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/user-profile");
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Modal show={show} size="md" centered onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>External Invoice Number</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <div
              class="alert alert-custom alert-light-primary fade show mb-5"
              role="alert"
            >
              <div class="alert-icon">
                <i class="flaticon-warning"></i>
              </div>
              <div class="alert-text">
                Please enter the invoice number correctly. This will help you to
                track the invoice later.
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label className="form-label">External Invoice Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="External Invoice Number"
                value={invoiceNumber}
                onChange={(e) => {
                  setInvoiceNumber(e.target.value)
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setShow(false)}
        >
          Cancel
        </button>
        <button
          disabled={isLoading || !invoiceNumber}
          type="button"
          className="btn btn-info"
          onClick={() => {
            if (ids?.length > 0) {
              handleGenerateInvoce();
            } else {
              handleGenerateInvoceByFilter();
            }
          }}
        >
          {isLoading ? "Please wait..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenerateMasterInvoiceModal;
